<template>
  <b-modal
    id="taxi-standing-order-list-modal"
    ref="refModal"
    size="lg"
    title="Taxi Standing Order List"
    ok-only
    ok-title="Close"
  >
    <div class="d-flex justify-content-end mt-1 mb-1">
      <b-button
        size="sm"
        variant="primary"
        @click="resetStandingOrderData"
        v-b-modal.taxi-standing-order-form-modal
      >
        Add new
      </b-button>
    </div>

    <b-card
      class="standing-order-list"
      no-body
    >
      <b-card-body>
        <div
          v-for="standingOrder in standingOrderList"
          :key="standingOrder.id"
          class="standing-order-item"
        >
          <b-media no-body>
            <b-media-aside>
              <b-avatar
                rounded
                size="42"
                :variant="(standingOrder.isActive) ? 'light-primary' : 'light-secondary'"
              >
                <feather-icon
                  size="18"
                  icon="DollarSignIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="w-100">
              <div class="d-flex align-items-center mb-25">
                <h6 class="mb-0">{{ standingOrder.standingOrderType.name }}</h6>
                <div class="ml-1">
                  <b-badge
                    :variant="(standingOrder.isActive) ? 'light-primary' : 'light-secondary'"
                    class="text-capitalize"
                  >
                    {{ frequencyName(standingOrder) }}
                  </b-badge>
                </div>
              </div>
              <small v-if="standingOrder.isActive">
                Next Run Date: {{ (standingOrder.lastStandingOrderExecution === null)
                  ? formatStandingOrderDate(standingOrder.startDateUtc)
                  : formatStandingOrderDate(standingOrder.lastStandingOrderExecution.nextRunDateUtc) }}
              </small>
            </b-media-body>
          </b-media>

          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreHorizontalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              @click="editStandingOrder(standingOrder)"
              v-b-modal.taxi-standing-order-form-modal
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-card-body>
    </b-card>


    <taxi-standing-order-form-modal
      :standingOrder="standingOrderData"
      @form-submitted="taxiStandingOrderFormSubmitted"
    />
  </b-modal>
</template>

<script>
import { BAvatar, BBadge, BButton, BCard, BCardBody, BCardText, BDropdown, BDropdownItem, BMedia, BMediaAside, BMediaBody, BModal } from "bootstrap-vue";
import { computed, ref } from "@vue/composition-api";
import router from '@/router';
import store from '@/store';
import Swal from 'sweetalert2';
import TaxiStandingOrderFormModal from '@/modules/taxi/components/modals/TaxiStandingOrderFormModal.vue';
import useTaxiStandingOrder from '@/modules/taxi/composables/useTaxiStandingOrder';
import useUtils from '@/composables/useUtils';

export default {
  setup() {
    const { formatDateDdMmYyyy, formatCurrency } = useUtils()
    const { getTaxiStandingOrders } = useTaxiStandingOrder();

    const standingOrderList = computed(() => store.getters['standingOrder/standingOrders']);
    const standingOrderData = ref({
      id: null,
      typeId: null,
      amount: null,
      isDaily: null,
      isWeekly: null,
      isMonthly: null,
      isYearly: null,
      isOneOff: null,
      taxiId: router.currentRoute.params.id,
      isActive: null,
      startDateUtc: null,
      lastStandingOrderExecution: null,
    });

    const formatStandingOrderDate = (date) => formatDateDdMmYyyy(date);

    const editStandingOrder = (data) => {
      standingOrderData.value = { ...data };

    };

    const frequencyName = (data) => {
      if (data.isDaily) return 'Daily';
      if (data.isWeekly) return 'Weekly';
      if (data.isMonthly) return 'Monthly';
      if (data.isYearly) return 'Yearly';
      if (data.isOneOff) return 'One Off';
    }

    const resetStandingOrderData = () => {
      standingOrderData.value = {
        id: null,
        typeId: null,
        amount: null,
        isDaily: null,
        isWeekly: null,
        isMonthly: null,
        isYearly: null,
        isOneOff: null,
        taxiId: router.currentRoute.params.id,
        isActive: null,
        startDateUtc: null,
        lastStandingOrderExecution: null,
      };
    };

    const taxiStandingOrderFormSubmitted = async (_) => {
      const taxiId = router.currentRoute.params.id;
      await getTaxiStandingOrders(taxiId);
    };

    return {
      // Reactive
      standingOrderData,
      standingOrderList,

      // Method
      formatStandingOrderDate,
      editStandingOrder,
      formatCurrency,
      frequencyName,
      resetStandingOrderData,
      taxiStandingOrderFormSubmitted
    };
  },
  components: {
    BAvatar,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BDropdown,
    BDropdownItem,
    BMedia,
    BMediaAside,
    BMediaBody,
    BModal,
    TaxiStandingOrderFormModal
  }
};
</script>

<style>
.standing-order-list .standing-order-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.standing-order-list .standing-order-item:not(:last-child) {
  margin-bottom: 1.2rem;
}

[dir=ltr] .standing-order-list .standing-order-item .avatar {
  margin-right: 1.2rem;
}

[dir=rtl] .standing-order-list .standing-order-item .avatar {
  margin-left: 1.2rem;
}

.standing-order-list .standing-order-item .avatar .avatar-content {
  width: 42px;
  height: 42px;
}
</style>